<script>
export default {
    name: 'Random',

    data() {
        return {
            background_colors: [
                "var(--color-blue-0)",
                "var(--color-blue-1)",               
                "var(--color-green-0)",
                "var(--color-orange-0)",
                "var(--color-orange-1)",
                "var(--color-yellow-0)",
                "var(--color-yellow-1)"
            ],

        }
    },

    methods: {
        sumOfCharsInString(str) {
            var result = 0;
            for (var i = 0; i < str.length; i++) {
                result += str.charCodeAt(i);
            }
            return result;
        },

        randomFromString(str, maxValue) {
            var seed = this.sumOfCharsInString(str);
            var result = Math.floor(((seed % 100) / 100) * maxValue);
            return result;
        },

        randomBackgroundColor(str) {
            var index = this.randomFromString(str, this.background_colors.length);
            return this.background_colors[index];
        }

    }
}
</script>
